import React from 'react';
import {API_URL} from '../index';
import Dialog from '@material-ui/core/Dialog';
import {useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
import EditIcon from '@material-ui/icons/Edit'
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import PersonIcon from '@material-ui/icons/Person';
import AddIcon from '@material-ui/icons/Add';
import Typography from '@material-ui/core/Typography';
import { blue } from '@material-ui/core/colors';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Container from '@material-ui/core/Container';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputLabel from '@material-ui/core/InputLabel';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Doc from './Doc';
import Tooltip from '@material-ui/core/Tooltip';


const useStyles = makeStyles(theme => ({

  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2),
    width: 150,
  },

}));

const Docs = forwardRef((props, ref) => {
  const classes = useStyles();

  const [fetching, setFetching] = useState(false);
  const [title, setTitle] = useState();
  const [token, setToken] = useState();
  const [documents, setDocuments] = useState();


  useEffect(() => {
      setFetching(true);
      setToken(localStorage.getItem('token'))
      const docs_url = API_URL + 'docs_by_organisation/?id=' + props.organisation_id
      fetch(docs_url, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        })
        .then(response => response.json())
        .then(data => setDocuments(data))
        .then(e => setFetching(false))
  }, []);

  const updateList = () => {
      setFetching(true);
      setToken(localStorage.getItem('token'))
      const docs_url = API_URL + 'docs_by_organisation/?id=' + props.organisation_id
      fetch(docs_url, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        })
        .then(response => response.json())
        .then(data => setDocuments(data))
        .then(e => setFetching(false))
  };

  useImperativeHandle(ref, () => ({
    update() {
        updateList();
    }
  }));

  return (
    <React.Fragment>
      <Container fullWidth>
      {documents != undefined && documents.count > 0 ?
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell>Вид документов</TableCell>
            <TableCell>Годы</TableCell>
            <TableCell>Местонахождение</TableCell>
            <TableCell>Архив</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {documents.results.map(doc => (
            <TableRow key={doc.id} hover onClick={() => console.log(doc)}>
              <TableCell component="th" scope="row">
                {doc.title}
              </TableCell>
              <TableCell component="th" scope="row">
                {doc.years}
              </TableCell>
              <TableCell component="th" scope="row">
                {doc.placement}
              </TableCell>
              <Tooltip title={<Typography variant="body1" gutterBottom>{doc.archive_ls != null ? doc.archive_ls.address : null}</Typography>} placement='left'>
              <TableCell component="th" scope="row">
                { doc.archive_ls != null ?
                 doc.archive_ls.title_short :
                 null }
              </TableCell>
              </Tooltip>
              {token != undefined ?
              <TableCell align="right">
                <Doc doc={doc} user={props.user} update_doclist={updateList} archive={props.archive} organisation={props.organisation}/>
              </TableCell> :
              <div></div>}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      :
      <div></div>}
      </Container>
    </React.Fragment>
  );
})

export default Docs;